import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { MarkupHelpers as Markup } from '../../../../../../helpers';
import { dateHelpers } from '../../../../../../helpers';

class ThreadItem extends Component {
    constructor(props) {
		super(props);
		this._isMounted = false;
        this.state = {
        pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342',
        }
    }

    componentDidMount = () => {
        this._isMounted = true
        const thread = this.props.thread;
        const id = thread.person_id;
        this.getPicture(id);        
    }
    componentWillUnmount(){
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
        const id = nextProps.thread.person_id;
        this.getPicture(id);
    }

    getPicture = (personId) => {
        const component = this;
        const url = `https://s3.intouchnetworks.com/getImage.php?id=${personId}`;
        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
            })
            .then(res => {
        if(this._isMounted){
                if (res !== undefined) {
                    component.setState({ pictureUrl: res });
                } else {
                    component.setState({ pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342' })
                }
        }
            })
    }

    render() {
        const src = this.state.pictureUrl;
        const {
            category
        } = this.props,
            {
                id,
                title,
                description,
                created_at,
                person,
                replies
            } = this.props.thread;

        const summary = description.substring(0, 60);
        const convertedTitle = Markup.escapeHtmlHelper(title),
            convertedSummary = Markup.escapeHtmlHelper(summary);
        return (
            <li className="col-12 forum-card">
                <div className="inner-card">
                    <div className="col-12 col-lg-10 forum-info">
                        <h4 className="col-12 heading-three">{convertedTitle}</h4>
                        <p className="body-copy" dangerouslySetInnerHTML={{ __html: `${convertedSummary}...` }}></p>
                        <div className="discussion-info-box">
                            <h4 className="body-copy">Posted: {dateHelpers.dateConverter(created_at)}</h4>
                            <h4 className="body-copy">Replies: {replies}</h4>
                        </div>
                        <Link className="theme-button secondary" to={`/forums/${category}/threads/${id}`}>
                            Read more
                        </Link>
                    </div>
                    <Link className="col-12 col-md-2 col-lg-2 user-profile-box" to={`/members/${this.props.thread.person_id}`}>
                        <img src={src} className="img-circle" alt="Member Img" />
                        <p className="user-name clickable">{person.first_name} {person.last_name}</p>
                    </Link>
                </div>
            </li>
        );
    };
}

ThreadItem.propTypes = {
    thread: PropTypes.object,
    category: PropTypes.string
}

export default ThreadItem;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/ThreadItem.js